import React, { useEffect, useState } from 'react'
import './pages.css'
import { useTranslation } from "react-i18next"
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Tooltip, Select, MenuItem, InputLabel, FormControl, Checkbox } from '@mui/material'
import { LoadingBar, BufferService } from 'src/M_Components'

export default function ColumnsConfig({ toastMessages, handleTabClose }) {
    const [roleName, setRoleName] = useState('')
    const [tableName, setTableName] = useState('')
    const [id, setId] = useState(sessionStorage.getItem('selectedTab'))
    const { t } = useTranslation()
    const [tableRows, setTableRows] = useState([])
    const [roles, SetRoles] = useState([])
    const getRoles = new BufferService('role')
    const [roleSelected, setRoleSelected] = useState(false)
    const [isFirst, setIsFirst] = useState(true)
    const [isLoaded, setIsLoaded] = useState(true)
    const [tableColumns, setTableColumns] = useState([])
    const sessionKeys = ['roleName', 'tableName', 'tableRows', 'roles', 'roleSelected', 'tableColumns']

    const mockup = [
        { ColumnName: "Field1", List: true, Index: 1 },
        { ColumnName: "Field2", List: true, Index: 2 },
        { ColumnName: "Field3", List: false, Index: 3 },
        { ColumnName: "Field4", List: false, Index: 4 },
        { ColumnName: "Field5", List: false, Index: 5 },
        { ColumnName: "Field6", List: false, Index: 6 },
        { ColumnName: "Field7", List: false, Index: 7 },
        { ColumnName: "Field8", List: false, Index: 8 },
        { ColumnName: "Field9", List: false, Index: 9 },
        { ColumnName: "Field10", List: false, Index: 10 },
        { ColumnName: "Field11", List: false, Index: 11 },
        { ColumnName: "Field12", List: false, Index: 12 },
        { ColumnName: "Field13", List: false, Index: 13 },
        { ColumnName: "Field14", List: false, Index: 14 },
        { ColumnName: "Field15", List: false, Index: 15 },
        { ColumnName: "Field16", List: false, Index: 16 },
        { ColumnName: "Field17", List: false, Index: 17 },
        { ColumnName: "Field18", List: false, Index: 18 },
        { ColumnName: "Field19", List: false, Index: 19 },
        { ColumnName: "Field20", List: false, Index: 20 },
        { ColumnName: "Field21", List: false, Index: 21 },
        { ColumnName: "Field22", List: false, Index: 22 },
        { ColumnName: "Field23", List: false, Index: 23 },
        { ColumnName: "Field24", List: false, Index: 24 },
        { ColumnName: "Field25", List: false, Index: 25 },
    ]

    const columnsMock = ['Table1', 'Table2', 'Table3']

    useEffect(() => {
        if (isFirst) {
            getSessionStorageData(id)
            sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys))
            setIsFirst(false)
        }
        // eslint-disable-next-line
    }, [])

    // eslint-disable-next-line
    useEffect(() => {
        const newId = sessionStorage.getItem('selectedTab')
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    useEffect(() => {
        sessionKeys.forEach((key) => {
            sessionStorageMachine(id, key, key)
        })
        // eslint-disable-next-line
    }, [id, roleName, tableName, tableRows, roles, roleSelected, tableColumns])

    const sessionStorageMachine = (id, key, value) => {
        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(Array.from(eval(value))))
        } else {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)))
        }
    }

    const getSessionStorageData = (sessionID) => {
        const tempRN = JSON.parse(sessionStorage.getItem(`${sessionID}roleName`))
        const tempTN = JSON.parse(sessionStorage.getItem(`${sessionID}tableName`))
        const tempTR = JSON.parse(sessionStorage.getItem(`${sessionID}tableRows`))
        const tempR = JSON.parse(sessionStorage.getItem(`${sessionID}roles`))
        const tempRS = JSON.parse(sessionStorage.getItem(`${sessionID}roleSelected`))
        const tempTC = JSON.parse(sessionStorage.getItem(`${sessionID}tableColumns`))

        if (tempRN || tempTN || tempTR || tempR || tempRS) {
            setRoleName(tempRN)
            setTableName(tempTN)
            setTableRows(tempTR)
            SetRoles(tempR)
            setRoleSelected(tempRS)
            setTableColumns(tempTC)
            setIsLoaded(false)
            return
        }
        get()
    }

    const get = () => {
        getRoles.get().then(dataRoles => {
            if (dataRoles.name === 'AxiosError') {
                handleTabClose(JSON.parse(id))
                toastMessages('error', dataRoles.message, '')
                return
            }

            dataRoles.Items.forEach(value => {
                SetRoles(prev => [...prev, value.Name])
            })
        })
        setIsLoaded(false)
    }

    const checkboxBody = (e) => {
        return (
            <div className='checkboxBodyDiv'>
                <Checkbox
                    disableRipple={true}
                    checked={e.List}
                    onChange={(elem) => changeTable(e.ColumnName, elem.target.checked)}
                    sx={{
                        color: 'var(--color-blue)',
                        '&.Mui-checked': {
                            color: 'var(--color-blue)',
                        },
                        '& .MuiSvgIcon-root': { fontSize: 28 },
                        padding: '0px'
                    }}
                />
            </div>
        )
    }

    const changeTable = (rowName, NewValue) => {
        // console.log("rowName", rowName)
        // console.log("NewValue", NewValue)

        setTableRows(tableRows.map(obj => {
            if (obj.ColumnName === rowName) {
                obj.List = NewValue
                return obj
            } else return obj
        }))
    }

    const getRefresh = () => {
        setRoleName('')
        setTableName('')
        setRoleSelected(false)
        setTableColumns([])
        setTableRows([])
    }

    const onSave = () => {

    }

    //post for getting table from backend by role (just need to insert name of role)
    const gettingTablesByRole = (value) => {
        // console.log("RolesName", value)
        setRoleSelected(true)
        setTableName("")
        setRoleName(value)

        //columns call
        setTableColumns(columnsMock)

        setIsLoaded(false)
    }

    //post for getting table columns from backend (just need to insert name of selected table)
    const gettingRowByName = (value) => {
        // console.log("TableName", value)
        setTableName(value)

        //rows call
        setTableRows(mockup)

        setIsLoaded(false)
    }

    return (
        <div className='firstDivContainer'>
            <div className='secoundDiv'>
                <div className='ColumnsButtonsDiv'>
                    <Tooltip title={t("RefreshTable")} onClick={() => { getRefresh() }}>
                        <div className='headerButtonsStyle'>
                            <i className="pi pi-refresh headerIcon"></i>
                            <span>{t("Refresh")}</span>
                        </div>
                    </Tooltip>
                    <Tooltip title={t("Save")} onClick={() => { onSave() }}>
                        <div className='headerButtonsStyle'>
                            <i className="pi pi-save headerIcon"></i>
                            <span>{t("Save")}</span>
                        </div>
                    </Tooltip>
                </div>
            </div>

            <div className='selectorsMainDiv'>
                <div className='selectorsDiv'>
                    <FormControl
                        sx={{
                            '& label': { color: 'var(--color-blue)' },
                            '& label.Mui-focused': { color: 'var(--color-blue)', borderColor: 'var(--color-black)' },
                            '& .MuiInput-underline:after': { color: 'var(--color-blue)', borderColor: "transparent" },
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: 'var(--color-blue-light)',
                                },
                                '&:hover fieldset': {
                                    borderColor: 'var(--color-blue)',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: 'var(--color-blue)',
                                },
                            },
                        }}
                        margin="dense"
                        fullWidth
                        size='small'
                        style={{ marginRight: '10px' }}
                    >
                        <InputLabel>Role</InputLabel>
                        <Select label={'Role'} value={roleName}>
                            <MenuItem value="" onClick={() => {
                                setRoleName("")
                                setRoleSelected(false)
                                setTableName("")
                            }}>
                                <em>None</em>
                            </MenuItem>
                            {roles.map((role, roleIndex) => (
                                <MenuItem key={roleIndex} disableRipple={true} value={role} onClick={() => {
                                    setIsLoaded(true)
                                    gettingTablesByRole(role)
                                }}> {role} </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
                <div className='selectorsDiv'>
                    <FormControl
                        sx={{
                            '& label': { color: 'var(--color-blue)' },
                            '& label.Mui-focused': { color: 'var(--color-blue)', borderColor: 'var(--color-black)' },
                            '& .MuiInput-underline:after': { color: 'var(--color-blue)', borderColor: "transparent" },
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: 'var(--color-blue-light)',
                                },
                                '&:hover fieldset': {
                                    borderColor: 'var(--color-blue)',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: 'var(--color-blue)',
                                },
                            },
                        }}
                        margin="dense"
                        fullWidth
                        size='small'
                        style={{ marginRight: '10px' }}
                    >
                        {roleSelected ? <InputLabel className='labelBlue'>{t("LabelTable")}</InputLabel> : <InputLabel className='labelGrey'>{t("LabelTable")}</InputLabel>}
                        <Select label={t("LabelTable")} value={tableName} disabled={roleSelected ? false : true}>
                            <MenuItem value="" onClick={() => { setTableName("") }}> <em>None</em> </MenuItem>
                            {tableColumns.map((col, colIndex) => (
                                <MenuItem key={colIndex} disableRipple={true} value={col} onClick={() => {
                                    setIsLoaded(true)
                                    gettingRowByName(col)
                                }}> {col} </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
            </div>

            <div className='tableDiv'>
                {tableName ? <DataTable
                    className='columnsDataTable'
                    value={tableRows}
                    size="small"
                    scrollable
                    scrollHeight="665px"
                    reorderableRows
                    onRowReorder={(e) => {
                        // console.log("e", e)
                        setTableRows(e.value)
                    }}
                    tableStyle={{ minWidth: '50rem', maxWidth: '80%' }}
                >
                    <Column header='' headerClassName="stickyToTopTableHeaders" rowReorder style={{ width: '3rem' }} />
                    <Column header='' headerClassName="stickyToTopTableHeaders" field='ColumnName' className='fieldColumnName'></Column>
                    <Column header='Visible' headerClassName="stickyToTopTableHeaders" body={(e) => checkboxBody(e)}></Column>
                </DataTable>
                    : <><span>{t("LabelNoSelectTable")}</span></>
                }
            </div>

            <div style={isLoaded ? { position: 'absolute', height: '90vh', width: '100%', zIndex: '5000000', top: '50px', backgroundColor: 'var(--color-grey-light)', opacity: '0.5' } : { position: 'absolute', height: '100%', width: '100%', display: 'none' }}>
                <LoadingBar />
            </div>
        </div >
    )
}